import React from "react";
import styles from "./schoolRitualBlockFour.module.css";
import LazySection from "../LazySection";

function SchoolRitualBlockFour({
  openingOfTheGatesRef,
  planetaryIntelligenciesRef,

  theSunArchetypeRef,
  theMoonArchetypeRef,
  planetaryResonanceRef,
  planetaryDecagramRef
}) {
  return (
    <>
      <div className={styles.school_ritual_psd4_mainWrp}>
        {/* ---------------------------block1------------------- */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block1_mainWrp}`}

          >
            <div className={styles.common_width}>
              <div className={styles.column} ref={openingOfTheGatesRef}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h2>Opening of the Gates</h2>
                </div>
              </div>

              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h2>
                      Opening of the Gates: Elemental Invocation in preparation
                      for the Planetary and Zodiacal Forces
                    </h2>
                    <h6>The Elemental Science of the Gates</h6>

                    <p>
                      When performing the <span>Theurgic Ritual of the Pentagram</span>—up to the invocation of our Divine Infinite Being, or through the first two of the five ritual sets—you are engaging in a complete model of Macrocosmic and Microcosmic invocation. This includes the full alignment with the Dēmiurgós, descending from the heavenly fire to the material earth, following the natural sequence of the four directions and the use of both banishing and invoking pentagrams within the framework of your personal demiurgy. Each of these rituals is complete in itself, even if performed alone. The first two ritual sets form the foundation of your daily practice, regardless of any additional work you undertake. Moving further into planetary and zodiacal work you must first open the gates.
                    </p>

                    <p>
                      The <span>Opening of the Gates</span> is a precise and deeply structured theurgical procedure that aligns the theurgist with the root elemental foundation of a planetary or zodiacal intelligence. While the Theurgic Ritual of the Pentagram up to this point is aligned with their respective elemental forces—Fire before you, Water to the right, Air behind, and Earth to the left —in this ritual you will utilize these four directions already empowered to directly open the gates. Here we become focused on invoking or banishing a specific elemental expression of a Planetary or Zodiacal Intelligence, each of which has a specific element as its root.
                    </p>


                    <p>
                      We will explore these elemental associations in greater depth when we cover the <span>DECAGRAM</span> later in this text. For now, as a quick reference, each planet and zodiac sign corresponds to a primary elemental base:
                    </p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="/image/ritual_9Aug_1st_img.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block2------------------- */}
        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block2_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.planatery_new_blk}>
                  <div className={styles.planatery_new_sub_blk}>
                    <h2>Planetary Elemental Correspondences</h2>
                  </div>
                  <div className={styles.planatery_new_sub_blk_flx_main}>
                    <div className={styles.planatery_new_sub_blk_flx_main_1st}>

                      <div className={styles.planatery_new_sub_blk_flx_main_sec_mini}>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini1st_img}>
                          <img src="/image/ritual_sun_icon.png" alt="icon" />
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini2nd_text}>
                          <p>Sun – <span>Spirit</span></p>
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini3rd_img}>
                          <img src="/image/ritual_sun_logo.png" alt="logo" />
                        </div>


                      </div>



                      <div className={styles.planatery_new_sub_blk_flx_main_sec_mini}>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini1st_img}>
                          <img src="/image/ritual_moon_icon.png" alt="icon" />
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini2nd_text}>
                          <p>Moon – <span>Water</span></p>
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini3rd_img}>
                          <img src="/image/ritual_moon_logo.png" alt="logo" />
                        </div>


                      </div>


                      <div className={styles.planatery_new_sub_blk_flx_main_sec_mini}>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini1st_img}>
                          <img src="/image/ritual_marcury_icon.png" alt="icon" />
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini2nd_text}>
                          <p>Mercury – <span>Air</span></p>
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini3rd_img}>
                          <img src="/image/ritual_air_new_icon.png" alt="logo" />
                        </div>


                      </div>


                      <div className={styles.planatery_new_sub_blk_flx_main_sec_mini}>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini1st_img}>
                          <img src="/image/ritual_venus_icon.png" alt="icon" />
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini2nd_text}>
                          <p>Venus – <span>Earth</span></p>
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini3rd_img}>
                          <img src="/image/ritual_earth_new_icon.png" alt="logo" />
                        </div>


                      </div>


                      <div className={styles.planatery_new_sub_blk_flx_main_sec_mini}>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini1st_img}>
                          <img src="/image/ritual_mars_icon.png" alt="icon" />
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini2nd_text}>
                          <p>Mars – <span>Fire</span></p>
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini3rd_img}>
                          <img src="/image/ritual_mars_logo.png" alt="logo" />
                        </div>


                      </div>


                      <div className={styles.planatery_new_sub_blk_flx_main_sec_mini}>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini1st_img}>
                          <img src="/image/ritual_jupitar_icon.png" alt="icon" />
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini2nd_text}>
                          <p>Jupiter – <span>Fire</span></p>
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini3rd_img}>
                          <img src="/image/ritual_mars_logo.png" alt="logo" />
                        </div>


                      </div>
                    </div>


                    <div className={styles.planatery_new_sub_blk_flx_main_1st}>

                      <div className={styles.planatery_new_sub_blk_flx_main_sec_mini}>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini1st_img}>
                          <img src="/image/ritual_sutarn_icon.png" alt="icon" />
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini2nd_text}>
                          <p>Saturn – <span>Earth</span></p>
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini3rd_img}>
                          <img src="/image/ritual_earth_new_icon.png" alt="logo" />
                        </div>


                      </div>


                      <div className={styles.planatery_new_sub_blk_flx_main_sec_mini}>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini1st_img}>
                          <img src="/image/ritual_urenus_icon.png" alt="icon" />
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini2nd_text}>
                          <p>Uranus – <span>Air</span></p>
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini3rd_img}>
                          <img src="/image/ritual_air_new_icon.png" alt="logo" />
                        </div>


                      </div>


                      <div className={styles.planatery_new_sub_blk_flx_main_sec_mini}>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini1st_img}>
                          <img src="/image/ritual_nepchun_icon.png" alt="icon" />
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini2nd_text}>
                          <p>Neptune – <span>Water</span></p>
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini3rd_img}>
                          <img src="/image/ritual_moon_logo.png" alt="logo" />
                        </div>


                      </div>


                      <div className={styles.planatery_new_sub_blk_flx_main_sec_mini}>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini1st_img}>
                          <img src="/image/ritual_pluto_icon.png" alt="icon" />
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini2nd_text}>
                          <p>Pluto – <span>Spirit</span></p>
                        </div>
                        <div className={styles.planatery_new_sub_blk_flx_main_sec_mini3rd_img}>
                          <img src="/image/ritual_sun_logo.png" alt="logo" />
                        </div>


                      </div>
                    </div>

                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="/image/ritual_9Aug_2nd_img.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>



        {/* -----------------------------blk2newsec--------------------------- */}
        <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block3_new_mainWrp}`}>
          <div className={styles.common_width}>

            <div className={styles.ritual_blocknew_11Aug_mainWrp}>
              <h3>Planetary <span>Elemental</span> Correspondences</h3>
              <div className={styles.ritual_blocknew_11Aug_mainWrp_flx}>
                <div className={styles.ritual_blocknew_11Aug_mainWrp_flx_sec}>
                  <div className={styles.ritual_blocknew_11Aug_mainWrp_banner}>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_icon}>
                      <img src="/image/ritual_mars_logo.png" alt="icon" />
                    </div>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_text}>
                      <p>Fire Signs  </p>
                    </div>

                  </div>

                  <div className={styles.ritual_blocknew_11Aug_mainWrp_section_Flx}>

                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_icon}>
                      <img src="/image/aries_icon.png" alt="icon" />
                    </div>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_text}>
                      <p>Aries,</p>
                    </div>
                  </div>

                  <div className={styles.ritual_blocknew_11Aug_mainWrp_section_Flx}>

                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_icon}>
                      <img src="/image/leo_icon.png" alt="icon" />
                    </div>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_text}>
                      <p>Leo, </p>
                    </div>
                  </div>

                  <div className={styles.ritual_blocknew_11Aug_mainWrp_section_Flx}>

                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_icon}>
                      <img src="/image/mystery_zodiacsign_saggitarius.webp" alt="icon" />
                    </div>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_text}>
                      <p>Sagittarius</p>
                    </div>
                  </div>
                </div>

                <div className={styles.ritual_blocknew_11Aug_mainWrp_flx_sec}>
                  <div className={styles.ritual_blocknew_11Aug_mainWrp_banner}>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_icon}>
                      <img src="/image/ritual_moon_logo.png" alt="icon" />
                    </div>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_text}>
                      <p>Water Signs  </p>
                    </div>

                  </div>

                  <div className={styles.ritual_blocknew_11Aug_mainWrp_section_Flx}>

                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_icon}>
                      <img src="/image/mystery_zodiacsign_cancer.webp" alt="icon" />
                    </div>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_text}>
                      <p>Cancer,</p>
                    </div>
                  </div>

                  <div className={styles.ritual_blocknew_11Aug_mainWrp_section_Flx}>

                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_icon}>
                      <img src="/image/mystery_zodiacsign_scorpio.webp" alt="icon" />
                    </div>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_text}>
                      <p>Scorpio, </p>
                    </div>
                  </div>

                  <div className={styles.ritual_blocknew_11Aug_mainWrp_section_Flx}>

                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_icon}>
                      <img src="/image/mystery_zodiacsign_gemini.webp" alt="icon" />
                    </div>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_text}>
                      <p>Pisces</p>
                    </div>
                  </div>
                </div>

                <div className={styles.ritual_blocknew_11Aug_mainWrp_flx_sec}>
                  <div className={styles.ritual_blocknew_11Aug_mainWrp_banner}>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_icon}>
                      <img src="/image/ritual_air_new_icon.png" alt="icon" />
                    </div>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_text}>
                      <p>Air Signs  </p>
                    </div>

                  </div>


                  <div className={styles.ritual_blocknew_11Aug_mainWrp_section_Flx}>

                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_icon}>
                      <img src="/image/mystery_zodiacsign_pisces.webp" alt="icon" />
                    </div>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_text}>
                      <p>Gemini,</p>
                    </div>
                  </div>

                  <div className={styles.ritual_blocknew_11Aug_mainWrp_section_Flx}>

                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_icon}>
                      <img src="/image/mystery_zodiacsign_libra.webp" alt="icon" />
                    </div>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_text}>
                      <p>Libra, </p>
                    </div>
                  </div>

                  <div className={styles.ritual_blocknew_11Aug_mainWrp_section_Flx}>

                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_icon}>
                      <img src="/image/mystery_zodiacsign_aquarius.webp" alt="icon" />
                    </div>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_text}>
                      <p>Aquarius</p>
                    </div>
                  </div>
                </div>

                <div className={styles.ritual_blocknew_11Aug_mainWrp_flx_sec}>
                  <div className={styles.ritual_blocknew_11Aug_mainWrp_banner}>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_icon}>
                      <img src="/image/ritual_earth_new_icon.png" alt="icon" />
                    </div>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_text}>
                      <p>Earth Signs  </p>
                    </div>

                  </div>

                  <div className={styles.ritual_blocknew_11Aug_mainWrp_section_Flx}>

                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_icon}>
                      <img src="/image/mystery_zodiacsign_tauras.webp" alt="icon" />
                    </div>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_text}>
                      <p>Taurus,</p>
                    </div>
                  </div>

                  <div className={styles.ritual_blocknew_11Aug_mainWrp_section_Flx}>

                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_icon}>
                      <img src="/image/mystery_zodiacsign_virgo.webp" alt="icon" />
                    </div>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_text}>
                      <p>Virgo,</p>
                    </div>
                  </div>

                  <div className={styles.ritual_blocknew_11Aug_mainWrp_section_Flx}>

                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_icon}>
                      <img src="/image/mystery_zodiacsign_capricorn.webp" alt="icon" />
                    </div>
                    <div className={styles.ritual_blocknew_11Aug_mainWrp_banner_text}>
                      <p>Capricorn</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ---------------------------block4------------------- */}
        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block4_mainWrp} ${styles.school_ritual_rules_for_building_21Aug_main_wrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h2>Rules for Building the Ritual Selection of the Gates</h2>


                  </div>
                </div>
              </div>

              <div className={styles.school_ritual_rules_for_building_21sub_1st_wrp}>
                <div className={styles.school_ritual_rules_for_building_21sub_1st_left}>
                  <h6>1. Elemental Framework</h6>
                  <p><span>The five elements form the primary structure:</span></p>
                  <img src="/image/school_ritual_rules_for_building_21sub_1st_left_img.webp" alt="image"/>
                </div>
                <div className={styles.school_ritual_rules_for_building_21sub_1st_right}>
                  <h6>2. Opening Gates</h6>
                  <p>Depending on the work, <span>any of the five gates</span> may be opened first.</p>
                  <p>If more than one gate is opened, they must always follow the <span>elemental hierarchy</span> above.</p>

                  <h6>4. Multiple Gates</h6>
                  <p>All planets and zodiacal presences within one gate are invoked before moving to the next.</p>
                  <p>If a second or third gate is required, it follows in proper <span>elemental succession</span>.</p>
                </div>

              </div>

               <div className={`${styles.school_ritual_rules_for_building_21sub_1st_wrp} ${styles.school_ritual_rules_for_building_21sub_2nd_wrp}`}>
                <div className={styles.school_ritual_rules_for_building_21sub_1st_left}>
                  <h6>3. Order within a Gate</h6>
                  <p><span>Once a gate is opened, invocations proceed in this sequence:</span></p>
                  <div className={styles.school_ritual_rules_for_building_21sub_2nd_sub}>
                    <div className={styles.school_ritual_rules_for_building_21sub_2nd_sub_sec_main}>
                      <p>Inner Planets:</p>
                      <div className={styles.school_ritual_rules_for_building_21sub_2nd_sub_sec_main_img_sec}>
                      <img src="/image/Inner_Planets_img.png" alt="icon"/>
                     
                      </div>
                      
                      
                      
                    </div>

                     <div className={styles.school_ritual_rules_for_building_21sub_2nd_sub_sec_main}>
                      <p>Outer Planets:</p>
                      <div className={styles.school_ritual_rules_for_building_21sub_2nd_sub_sec_main_img_sec}>
                      <img src="/image/Outer_Planets_img.png" alt="icon"/>
                     
                      </div>
                      
                      
                      
                    </div>

                    <div className={styles.school_ritual_rules_for_building_21sub_2nd_sub_sec_main}>
                      <p>Zodiacal Presences: in the order of</p>
                      <div className={styles.school_ritual_rules_for_building_21sub_2nd_sub_sec_main_img_sec}>
                      <img src="/image/Zodiacal_Presences_img.png" alt="icon"/>
                     
                      </div>
                      
                      
                      
                    </div>
                  </div>
                </div>
                <div className={styles.school_ritual_rules_for_building_21sub_1st_right}>
                  <img src="/image/school_ritual_rules_for_building_21sub_1st_right_img_new.webp" alt="school_ritual_rules_for_building_21sub_1st_right_img"/>
                 
                </div>

              </div>


            </div>
          </div>

        </LazySection>


        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block4_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h6>
                      The Function of Banishing vs. Invocation
                    </h6>

                    <p>In the standard Pentagram Ritual across the first two sets, the theurgist — especially when invoking our <span>Divine Infinite Being</span> — may perform a full cycle beginning with the Banishing of the Pentagrams, immediately followed by the Invoking of the Pentagrams. This purifies the space and then embodies the Dēmiurgós through the four directions, after which the daemonic guardians are invoked, and the rite is brought to its close.</p>

                    <p>When performing the later three rituals in the set, where planetary and zodiacal forces are to be embodied, the procedure shifts: only the Banishing of the Pentagrams is performed, followed by the invocation of the daemonic guardians. From there, the theurgist proceeds directly to the invocation of Hermes–Apollo, preparing the field for the opening of the gates.</p>
                    <p>
                      When opening the gates of a Planetary intelligence the theurgist must first determine whether the ritual will be performed as a banishing <span>(to purify, correct, and clear distortions of consciousness)</span> or an invocation <span>(to unify with and embody the Divine Intelligence)</span>. This distinction is enacted through the form of the pentagram drawn at each gate:
                    </p>
                    <p>You will use these pronouncements for all of the gates, each coupled with the resonant Divine Name of the <span>Dēmiurgós</span> of that station. Always begin facing Fire, regardless of which element is being opened. In the formula below, fill in the <span>[brackets]</span> with the specific root element, and again with the Divine Intelligence being banished or invoked.</p>
                    {/* 
                    <ul>
                      <li>Banishing: Draw the banishing pentagram of the root element.</li>
                      <li>Invocation: Draw the invoking pentagram of the root element.</li>
                    </ul>

                    <p>
                      For effective planetary invocation, it is often recommended to perform banishing rituals multiple times—three or more days in succession—prior to the invocation proper. This repeated clearing not only refines the ritual space but also calibrates the theurgist’s own subtle body, ensuring that their inner field is fully clarified and attuned. In doing so, the mind, emotions, and energetic layers are freed from accumulated static, residual impressions, and unconscious resistances that might refract or cloud the incoming presence of the planetary god. Such banishing is aimed at dissolving these distortions, harmonizing the field so that when the planetary intelligence arrives, its force can be received in its pure, undiluted form. The result is a more stable, coherent state in which the theurgist can meet the god directly, without interference from the lingering debris of prior conditions or psychic entanglements.

                    </p> */}
                  </div>
                </div>



                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                    src="/image/school_ritual_psd4_block4_mainWrp_bg_new_1199px.webp"
                    alt="Image"
                  />
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                    src="/image/school_ritual_psd4_block4_mainWrp_bg_new.webp"
                    alt="Image"
                  />
                </div>


              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block3------------------- */}
        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block3_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    {/* <p>
                      When invoking a Divine Intelligence such as Mercury, the theurgist opens themselves fully to its
                      overwhelming, infinite presence. This is a trans-conscious unification in which the deity becomes
                      embodied in and through the theurgist. Time, space, and identity may fracture or dissolve temporarily as the archetypal intelligence merges with the individual. This direct, revelatory union allows the force to reshape every facet of the theurgist’s life in accordance with its essence. With repeated invocation, one begins to perceive and harmonize with the planetary force across all aspects of experience.
                    </p> */}
                    <h6>Banishing: </h6>
                    <ul>
                      <li>Draw the banishing pentagram of the root element in every direction, pronouncing each station.</li>
                      <li>Banishing Pronouncement: <span>“Standing before the blazing Pentagram of [element direction] I banish and purify [root element] of [element direction] in preparation for the divine intelligence [name planet]”</span></li>
                      <li>Draw the banishing pentagram of <span>[root element]</span>, resonate <span>[root element] Dēmiurgós</span> divine name from the pentagram instructions above.</li>
                    </ul>
                    <h6>Invocation: </h6>
                    <ul>
                      <li>Draw the invoking pentagram of the root element in every direction, pronouncing each station.</li>
                      <li>Invocation Pronouncement: <span>“Standing before the blazing Pentagram of [element direction] I invoke and embody [root element] of [element  direction] in preparation for the divine intelligence [name planet or zodiac sign]”</span></li>
                      <li>Draw the invoking pentagram of <span>[root element]</span>, resonate <span>[root element] Dēmiurgós</span> divine name from the pentagram instructions above.</li>
                    </ul>
                    <p>Example Invocation: Root element Air, Planetary Invocation Mercury <span>(same for banishing only draw the banishing pentagram instead)</span></p>
                    <p>
                      Draw the invoking pentagram of the root element in every direction, pronouncing each station.
                    </p>

                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                    src="/image/school_ritual_psd4_block3_mainWrp_bg_new.webp"
                    alt="Image"
                  />
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                    src="/image/school_ritual_psd4_block3_mainWrp_bg_new.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>


        {/* ---------------------------block11Aug_blk5------------------- */}
        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block4_mainWrp} ${styles.school_ritual_psd4_block5_11Aug_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>

<h2>Worked Example — Opening the Gates of Air (Mercury)</h2>
<p>
Model of the Quick Reference for an Air-gate. <span>Root element: Air.</span> At each station—<span>Fire</span> → <span>Water</span> → <span>Air</span> → <span>Earth</span>—draw the <span>Invoking Pentagram of Air</span>, then seal <span>within the Human Frame (Spirit)</span>. Speak: <span>“Air of [Station] in preparation for the divine intelligence Mercury,”</span> then resonate the Air divine name from <span><i>Pentagrams—Invoking</i>: Aer Dēmiurgós</span>. For other gates/planets, substitute the correct root element, planet, and divine name per the Quick Reference.
 </p>

                    <h6>Facing Fire:</h6>
                    <ul>
                      <li>Pronouncement/Declaration: <span>“Standing before the blazing Pentagram of Fire I invoke and embody Air of Fire in preparation for the divine intelligence Mercury”</span></li>
                      <li>Draw the invoking pentagram of Air, resonate the Air Dēmiurgós divine name from the pentagram instructions above.</li>
                      <li className={styles.ritual_praxis_subpoint}><span>AaaaaaaeeeeeeerrrrrrrDddddddeeeeeeemmmmmmmiiiiiiiuuuuuuurrrrrrrgggggggooooooosssssss</span></li>
                    </ul>
                    <h6>Facing Water:</h6>
                    <ul>
                      <li>Pronouncement/Declaration: <span>“Standing before the blazing Pentagram of Water I invoke and embody Air of Water in preparation for the divine intelligence Mercury”</span></li>
                      <li>Draw the invoking pentagram of Air, resonate the Air Dēmiurgós divine name from the pentagram instructions above.</li>
                      <li className={styles.ritual_praxis_subpoint}><span>AaaaaaaeeeeeeerrrrrrrDddddddeeeeeeemmmmmmmiiiiiiiuuuuuuurrrrrrrgggggggooooooosssssss</span></li>
                    </ul>
                    <h6>Facing Air:</h6>
                    <ul>
                      <li>Pronouncement/Declaration: <span>“Standing before the blazing Pentagram of Air I invoke and embody Air of Air in preparation for the divine intelligence Mercury”</span></li>
                      <li>Draw the invoking pentagram of Air, resonate the Air Dēmiurgós divine name from the pentagram instructions above.</li>
                      <li className={styles.ritual_praxis_subpoint}><span>AaaaaaaeeeeeeerrrrrrrDddddddeeeeeeemmmmmmmiiiiiiiuuuuuuurrrrrrrgggggggooooooosssssss</span></li>
                    </ul>
                    <h6>Facing Earth:</h6>
                    <ul>
                      <li>Pronouncement/Declaration: <span>“Standing before the blazing Pentagram of Earth I invoke and embody Air of Earth in preparation for the divine intelligence Mercury”</span></li>
                      <li>Draw the invoking pentagram of Air, resonate the Air Dēmiurgós divine name from the pentagram instructions above.</li>
                      <li className={styles.ritual_praxis_subpoint}><span>AaaaaaaeeeeeeerrrrrrrDddddddeeeeeeemmmmmmmiiiiiiiuuuuuuurrrrrrrgggggggooooooosssssss</span></li>
                    </ul>
                    {/* <p>You would then draw them into the human frame through the Fifth element of Spirit.</p> */}
                    <h6>Facing Fire, Spirit Drawn within the Human Frame:</h6>
                    <ul>
                      <li>Pronouncement/Declaration: <span>“Standing within the Blazing Pentagrams of Fire, Water, Air and Earth, I focus within the self. I invoke and embody Air of Spirit in preparation for the divine intelligence of the Mercury”</span></li>
                      <li>Draw the invoking pentagram of Air within the human frame, resonate the Air Dēmiurgós divine name from the pentagram instructions above.</li>
                      <li className={styles.ritual_praxis_subpoint}><span>AaaaaaaeeeeeeerrrrrrrDddddddeeeeeeemmmmmmmiiiiiiiuuuuuuurrrrrrrgggggggooooooosssssss</span></li>
                    </ul>


                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="/image/school_ritual_psd4_block5_11Aug_mainWrp_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block11Aug_blk6------------------- */}
        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block3_mainWrp} ${styles.school_ritual_psd4_block6_11Aug_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h6>The Fifth Element: Spirit as Axis and Completion</h6>
                    <p>
                      Opening of the Gates includes the invocation of the fifth element: Spirit. This is not merely a symbolic addition but the actual axis around which the other elements rotate. Spirit is both the source and culmination of the ritual, residing in the vertical dimension—above and within, as well as the root element of the Sun and Pluto.
                    </p>
                    <p>

                      This fifth element, the Spirit, is the <span>Αἰθήρ (Aithēr)</span>. In ancient usage, Aithēr was the <span>“upper air,”</span> the radiant and pure atmosphere above the clouds, the fiery and incorruptible substance of the heavens. Aristotle and Theophrastus identified it as the eternal element distinct from the four terrestrial forms, the quintessence that does not decay. In the currents of Neoplatonism and later theurgy, Aithēr came to be understood as the subtle medium through which divine light and celestial intelligences move, the shining field that binds the cosmos together. It is not one element among the others but their crown and axis—the Spirit that completes the elemental lattice and makes the theurgist’s invocation a true opening to the gods. Instead of being associated with one of the Aces in the Minor Arcana, Spirit is associated with the Fool in the Greater Arcana—the root of all the Archetypes at the beginning of the journey.
                    </p>

                    <p>
                      The resonant divine name is <span>Aithēr Dēmiurgós</span>, which will be used when the root element is Spirit such as in the opening of the gates for the Sun or Pluto, following its own tracing of the pentagram as we show in our diagrams for banishing and invocation. It’s pronouncement:

                    </p>
                    <p><span>AaaatthhhheeerrrrrDeeeemmmiiiuuurrrgggooossssss</span></p>
                    <p>The ritual begins in the direction of Fire <span>(traditionally East, or wherever the altar is placed)</span>, the banishing/invocation proceeds through all four elemental directions—Fire, Water, Air, Earth—culminating in the central axis of Spirit.</p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                    src="/image/school_ritual_psd4_block6_11Aug_mainWrp_bg.webp"
                    alt="Image"
                  />
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                    src="/image/school_ritual_psd4_block6_11Aug_mainWrp_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block11Aug_blk7------------------- */}
        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block4_mainWrp} ${styles.school_ritual_psd4_block7_11Aug_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>


                    <p>As the theurgist moves through the four elements, they are constructing the elemental lattice of the sacred space, empowering the root element in preparation for divine intelligence. The fifth point of the pentagram is not only drawn—it is embodied. The theurgist becomes the living fifth element, the conscious vessel through which the divine force enters and acts in the world.</p>
                    <p>
                      The final gesture in the Opening of the Gates is the drawing of the Spirit Pentagram within the human frame, as if you were backing into the pentagram, aligning yourself with it as though it were traced behind you in space. Visualize your body as a living pentagram: the top of the head is the apex—Spirit; the left arm extended is Water; the right arm extended is Air; the left foot extended is Fire; and the right foot extended is Earth.</p>




                    <p>
                      TTo trace the Spirit Pentagram—especially when working with planets or forces closely aligned with Spirit, such as the Sun or Pluto—begin from the crown of the head, the point of Spirit itself. From there, proceed through the other elemental points according to the pentagram pattern for the force being invoked or banished. If, however, you are invoking a different root element <span>(for example, Air)</span>, you do not begin at the crown but at its own elemental root <span>(Air at the right arm, Fire at the left arm, Water at the left leg, Earth at the right leg)</span>. In every case, the figure is drawn deliberately across and through your body, so that the pentagram is not merely imagined in front of you but embodied as the living structure of the elements themselves.
                    </p>

                    <p>This act completes the elemental lattice and opens the gate fully to the Divine Intelligence associated with the invoked planetary or zodiacal force. By embodying the fifth element—Spirit—within your own form, you create a living axis between the finite world of the theurgist and the infinite realm of the Divine. In this moment you are the pentagram: the Sign of Man, radiant and upright, established as a living seal within the column of the gods. The lines you have traced through your body ignite the inner geometry of harmony, for the pentagram sets into motion the golden ratio—its radiance unfolding the secret mathematics of divine proportion. This golden current reawakens the body of light once more, your own being becomes the threshold. In this state, the pentagram is not just a sign but a transformation—your form aligned to the eternal pattern, your breath resonant with the rhythm of the spheres, your soul opened as vessel and star alike.</p>

                  </div>
                </div>



                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                    src="/image/school_ritual_psd4_block7_11Aug_mainWrp_1199_bg.webp"
                    alt="Image"
                  />
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                    src="/image/school_ritual_psd4_block7_11Aug_mainWrp_1920_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block11Aug_blk8------------------- */}
        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block3_mainWrp} ${styles.school_ritual_psd4_block8_11Aug_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h6>Banishing and Invocation, balanced through the Open Gate</h6>


                    <p>For effective planetary invocation, it is often recommended to perform banishing rituals multiple times—three or more days in succession—prior to the invocation proper. This repeated clearing not only refines the ritual space but also calibrates the theurgist’s own subtle body, ensuring that their inner field is fully clarified and attuned. In doing so, the mind, emotions, and energetic layers are freed from accumulated static, residual impressions, and unconscious resistances that might refract or cloud the incoming presence of the planetary god. Such banishing is aimed at dissolving these distortions, harmonizing the field so that when the planetary intelligence arrives, its force can be received in its pure, undiluted form. The result is a more stable, coherent state in which the theurgist can meet the god directly, without interference from the lingering debris of prior conditions or psychic entanglements.</p>

                    <p>
                      When preparing for the banishing of the Divine Intelligence of Mercury for example, what is accomplished is personal, internal, and based on the diluted or incorrect interpretation of the influence of the Archetype on the consciousness of the theurgist.
                    </p>


                  </div>
                </div>



                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                    src="/image/school_ritual_psd4_block8_11Aug_mainWrp_bg_1199px.webp"
                    alt="Image"
                  />
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                    src="/image/school_ritual_psd4_block8_11Aug_mainWrp_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>


        {/* ---------------------------block19Aug_blk8------------------- */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block4_mainWrp} ${styles.school_ritual_psd4_block8_19Aug_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>


                    <p>Choosing this preparatory work centers attention on the personal and internal aspects of spiritual discipline. Specifically, it addresses the clearing away of misconceptions and subtle personal interpretations shaped by the archetype of Mercury within the theurgist’s consciousness. This effort is not limited to the current planetary influence but also involves reassessing and purifying the accumulated effects of past experiences, including those repressed or formative events that have helped shape the psyche over time. Before invoking the Divine Intelligence of Mercury, it is recommended to spend several days engaged in focused clearing of the planetary influence, returning to the work more than once, and maintaining an acute awareness of its effects throughout the day between sessions.</p>
                    <p>It’s important to note that the banishment is directed not at the Divine Intelligences themselves—which are wholes beyond human comprehension—but rather at the theurgist's own psychological constructs and energetic patterns that have formed in response to these archetypal influences. Thus, the aim is to purify the personal psychology and the constellation of psychological content related to the archetype, rather than the transcendent and transconscious nature of the Divine Intelligence itself.</p>
                    <p>When invoking Mercury one is inviting the Divine Intelligence to possess and transform the theurgist directly with their infinite and immortal natures bonding with and overwhelming the theurgist in a transconscious direct experience of divinatory and revelatory power. When properly invoking the theurgist will experience a breaking of space/time and a concentrated very specific identification of the self with the Mercurial intelligence. Success in invocation will be obvious and apparent not only during ritual but through the transformative presence that will shape every experience where Mercury is concerned moving forward. Through successive invocations the theurgist will begin to recognize the mercurial forces and overtime will attune to their influence allowing one to consciously employ the force of its presence activity. This may take several invocations over the course of several weeks with breaks in between to absorb the energies directly.</p>

                  </div>
                </div>



                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                    src="/image/central-doctrain-new/CD_chap_7_img_1.webp"
                    alt="Image"
                  />
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                    src="/image/central-doctrain-new/CD_chap_7_img_1.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block11Aug_blk9------------------- */}
        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block3_mainWrp} ${styles.school_ritual_psd4_block9_11Aug_19Aug_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>





                    <p>
                      Due to the sheer magnitude of the experience, the banishing or invocation of a planetary sphere must be firmly anchored in all four directions of the ritual space through the root element associated with that sphere. This elemental grounding stabilizes the theurgist in the midst of the planetary god’s overwhelming presence. For this reason, the <span><i>Opening of the Gates</i></span>—performed in the manner proper to the planet being engaged—is indispensable, and always precedes the direct summoning of the planetary or zodiacal force.
                    </p>

                    <p>Whether one is invoking or banishing, the Gate must first be opened, and the Planetary Divine Intelligence is still directly invoked afterward. Banishing does not drive the Intelligence away; rather, it calls the god’s presence into the field so that its own agency may purge, cleanse, and realign the soul. Invocation, by contrast, draws that same presence inward, so that the self may be reshaped in its likeness. Thus, the distinction is not in whether the planetary god is present, but in the intention of the theurgist: to invite purification and release, or to invite full embodiment and transformation.</p>

                    <p>
                      The zodiacal intelligences are not merely celestial markers, but the very personality of the Sun—the differentiated expressions of the Solar Logos, or its solar Atman, as it unfolds through the twelvefold order of the tropical zodiac. They constitute the radiant atmosphere of divine illumination itself—not separate from the Sun’s consciousness, but its articulated breath across the heavens. As the Sun moves through each sign, it reveals a distinct facet of cosmic intelligence, shaping the archetypal rhythm of becoming.
                    </p>



                  </div>
                </div>



                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                    src="/image/central-doctrain-new/central_doc_main_page_2nd_img.webp"
                    alt="Image"
                  />
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                    src="/image/central-doctrain-new/central_doc_main_page_2nd_img.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>


        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block4_mainWrp} ${styles.school_ritual_psd4_block9_11Aug_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>






                    <p>When theurgically engaging a zodiacal gate, there is no banishing—only invocation. The zodiacal intelligences are not energies that arrive from outside the ritual space; they are the ever-present conditions of the sacred field itself. Unlike the planetary gods—who correspond to the theurgist’s inner psychic structure and the gifts of divination, prophecy, and manifestation, the Microcosm in resonance with the infinite planetary powers—the zodiacal intelligences form the encompassing macrocosmic atmosphere within which those inner forces move, unfold, and take shape. They are not powers to be purified before contact, but the archetypal environment in which divine action finds order, coherence, and luminosity.</p>

                    <p>To invoke the zodiac is not to draw down a distant influence, but to become aware of a greater presence already surrounding and permeating the self. The theurgist does not come into alignment with the zodiac as a separate force, but undergoes a transition through its living current—stepping consciously into the flow of the cosmic order of the Sun. It is an attunement to the divine breath in which all planetary and daemonic forces find their context and orientation. In this way, the zodiac is not a set of forces to be harnessed, but a divine atmosphere to be inhabited.</p>

                  </div>
                </div>



                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                    src="/image/school_ritual_psd4_block9_11Aug_mainWrp_bg.webp"
                    alt="Image"
                  />
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                    src="/image/school_ritual_psd4_block9_11Aug_mainWrp_bg_new.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>


        {/* ---------------------------block11Aug_blk10------------------- */}
        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block3_mainWrp} ${styles.school_ritual_psd4_block10_11Aug_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h6>Opening of the gates and the Celestial Ritual of the Pentagram</h6>


                    <p>The <span>Celestial Ritual of the Pentagram</span> is the most complete and integrative of the five ritual forms. It is the cornerstone rite of the 15-month curriculum, for it uniquely unites the full spectrum of theurgic engagement: the Decan system of the Pentagram, the Astrological Wheel, the Tarot trumps, and the ongoing work of nativity, transit, and manifestation. Unlike the more specialized operations, this rite brings planetary and zodiacal intelligences into a single field, where their powers may be invoked in harmonious consort. </p>

                    <p>
                      The opening of the gates is the essential act that makes this integration possible. In cases where planet and sign are naturally conjoined—for example, Neptune in Pisces, where both correspond to the element of Water—the gate for that single element is opened once, becoming the threshold through which both presences may be invoked in sequence: first the planetary intelligence, then the zodiacal. The shared elemental ground binds them together, allowing the theurgist to feel their resonance as a unified current of divine influence.
                    </p>

                    <p>When planet and sign belong to different elements, however, the work becomes more layered. One begins by opening the elemental gate proper to the planet, calling forth its intelligence and aligning with its specific current. Once the planetary invocation is complete, the theurgist then opens the separate elemental gate proper to the sign, invoking its zodiacal intelligence as a distinct but complementary presence. The dual gates create a polarity in the ritual field, within which the planetary god and the zodiacal arché may be held together in dialogue.</p>
                    <p>In both cases, the Celestial Ritual of the Pentagram teaches the theurgist that neither the planetary nor the zodiacal current can be reduced to the other. The planetary intelligences are the divine agents of action, prophecy, and transformation, moving through the soul as powers that shape and direct. The zodiacal intelligences are the vast celestial conditions—the archetypal atmospheres of eternity—within which those powers unfold and find their form. The rite therefore becomes a living image of the cosmos itself: planets as radiant actors, signs as the eternal stage, both joined within the embodied axis of the theurgist who now stands as the microcosm of the whole.</p>

                  </div>
                </div>



                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                    src="/image/school_ritual_psd4_block10_11Aug_mainWrp_bg_19aug.webp"
                    alt="Image"
                  />
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                    src="/image/school_ritual_psd4_block10_11Aug_mainWrp_bg_19aug.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>
        {/* ---------------------------block11Aug_blk11------------------- */}
        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block4_mainWrp} ${styles.school_ritual_psd4_block11_11Aug_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>

                    <h6>The Court Cards and the Gates</h6>

                    <p>
                      In working with the Opening of the Gates, I strongly recommend the study of the <span>Court Cards of the Tarot</span> as a supplement for ingraining the personality of the transitions you are ritually engaging. Each Court Card embodies not only a living elemental pattern but also a <span>specific span of the zodiac</span>, bridging the flow of decans across the Astrological Wheel of the Tarot <span>(ROTA)</span>. In this way, they serve as both initiatory figures and mnemonic guides, grounding the abstract motions of the heavens in recognizable, humanized forms.
                    </p>

                    <p>The four ranks employed in the Greater Arcana Tarot are: <span>Knight, Queen, Prince, and Princess</span>. Each carries a double-elemental designation that describes its essential character. For example:</p>

                    <ul>
                      <li>The <span>Knight of Wands</span> is <span><i>Fire of Fire</i></span>—a burst of pure will, dynamic movement, and consuming passion.</li>
                      <li>The <span>Princess of Cups</span> is <span><i>Water of Earth</i></span>—the deep well of feeling rising through matter into sensitivity and reflection.</li>
                    </ul>

                    <p>
                      These elemental combinations reveal how each court expresses itself as a distinct mode of personality. They represent the ways the elemental powers inhabit the human form, giving them voice, temperament, and agency.
                    </p>
                    <p>Crucially, the first three Court Cards also embody the <span>transitional zones</span> of the zodiac. Each Knight, Queen, Prince spans not a whole sign but a bridge—covering the <span>last two decans of one sign and the first decan of the next.</span> The Princesses stand in station to a full quarter of the zodiac encompassing the four elements around the wheel. In this way, they teach us how to navigate liminal thresholds, the very places where energies shift, overlap, and transform. When you stand before a Gate, you are not simply calling upon a static force, but entering the <span>living personality of transition</span> itself.</p>

                    <p>By meditating on the Court Cards in tandem with your Gate work, you begin to internalize the qualities of these transitions. They become less a set of intellectual correspondences and more a living memory in your psychic body: the quickening fire of a Knight, the steady sovereignty of a Queen, the aspirational drive of a Prince, the receptive grounding of a Princess. Each Court offers a way to inhabit the movement of energies as they pass from one astrological space into another.</p>

                    <p>In this way, the Court Cards act as companions to the Opening of the Gates—figures who personify the liminal, transitional nature of the zodiacal and planetary paths you are ritually traversing. They provide theurgic personality to what might otherwise remain abstract, allowing you to meet the transitions not as distant calculations but as presences you can engage, embody, and ultimately become.</p>

                  </div>
                </div>



                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                    src="/image/school_ritual_psd4_block11_11Aug_mainWrp_bg_20Aug.webp"
                    alt="Image"
                  />
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                    src="/image/school_ritual_psd4_block11_11Aug_mainWrp_bg_20Aug.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>




        {/* ---------------------------block5main------------------- */}

        {/* <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block5_mainWrp}`}
            ref={planetaryIntelligenciesRef}
          >
            <div className={styles.common_width}>
              <div className={styles.column}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h2>Planetary Intelligencies and The Zodiac House of Sun</h2>
                </div>
              </div>

              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <p>
                      The ritual praxis of our school distinguishes between
                      planetary intelligences and zodiacal energies, viewing
                      them as fundamentally different aspects of cosmic
                      influence. Planetary intelligences are perceived as
                      dynamic, independent forces, akin to conscious entities,
                      with which one can actively engage. Ritualistically, this
                      engagement involves a process of purification, wherein
                      discordant energies are dispelled to create a clear
                      channel for communication. Following this, the
                      intelligence is invoked, not as an act of domination, but
                      as a respectful invitation for its specific qualities to
                      manifest within the ritual space and the practitioner's
                      consciousness. This interaction is akin to establishing a
                      working relationship with a powerful ally, where one seeks
                      to align their will with the intelligence's inherent
                      nature, allowing its energy to flow and inform the
                      ritual's purpose.
                    </p>

                    <p>
                      In contrast, the zodiac signs are understood as phases or
                      aspects of the Sun's overarching personality. They
                      represent the cyclical unfolding of solar energy, akin to
                      entering different rooms within a grand house, each
                      possessing a unique atmosphere and character. Unlike
                      planetary intelligences, zodiacal energies are not invoked
                      or banished. Instead, the practitioner attunes themselves
                      to the prevailing solar phase, immersing themselves in its
                      encompassing influence. This is a process of resonance,
                      where one seeks to align their consciousness with the
                      current expression of the Sun's energy, allowing its
                      qualities to permeate their being. For instance, entering
                      the phase of Taurus involves allowing the Sun's grounding,
                      stabilizing influence to manifest, rather than summoning
                      an external entity.
                    </p>
                    <p>
                      This distinction allows for a dual approach to ritual.
                      Planetary intelligences are treated as distinct agents,
                      capable of independent action, with which one can engage
                      in a dynamic exchange. Zodiacal energies, on the other
                      hand, are viewed as expressions of a larger, encompassing
                      whole, representing the cyclical rhythms of the Sun's
                      journey. This approach acknowledges both the specific,
                      focused influence of planetary intelligences and the
                      broad, pervasive influence of solar cycles, creating a
                      holistic framework for ritual practice. It is a dance
                      between the specific and the universal, allowing for both
                      focused interaction with distinct energies and a deeper
                      alignment with the grander cosmic rhythms.
                    </p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd4_block5_mainWrp_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection> */}

        {/* ---------------------------block6-------------------  */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block6_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div className={styles.column} ref={planetaryDecagramRef}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h2>PLANETARY INTELLIGENCES ACROSS THE DECAGRAM</h2>
                </div>
              </div>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h3>
                      Planetary Intelligences and their Purification and
                      Invocations
                    </h3>

                    <p>
                      The vast agency of Planetary Intelligence, the celestial bodies encircling our solar center, exerts dynamic forces that profoundly influence human experience, both through the direct shaping of events over time and through the imprinting of archetypal patterns onto our perception of the world. While not exhaustive, the Tarot Trumps, with their planetary and zodiacal associations, offer a valuable tool for studying these archetypes and their symbolic meanings. It is strongly recommended that the aspirant engage in thorough self-reflection, examining how these archetypes have manifested in their own lives, to gain a deeper understanding of their influence.
                    </p>
                    <p>Within this framework, the <span>Decagram</span> stands as a central emblem: formed from two interlaced pentagrams, it expresses the tenfold order of the planetary spheres. This is not a ritual implement but a contemplative symbol, a figure designed to reorient awareness toward the wholeness of celestial harmony. To work with the Decagram is to impress upon the imagination the unified field of planetary forces—each point carrying its own distinct intelligence, yet bound together in a single star of stars. Its power lies not in ceremonial use but in its ability to reshape inner vision, guiding the aspirant to perceive the planetary order as a living architecture of the cosmos.</p>
                    <p>Once this personal study and contemplation are sufficient, those who engage with Planetary Intelligence through ritualistic practices aim to connect with the infinite, immortal form of the intelligence itself. This pursuit seeks to purify one’s connection to these energies and ultimately achieve a direct union with the vast agency of their form—taking the shape of their divinity, becoming an agent of their higher manifestation, and moving beyond the myriad surface expressions of their influence to grasp their fundamental essence.</p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd4_block6_mainWrp_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block7-------------------  */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block7_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h3>Associations and Symbolic Orientations</h3>

                    <p>
                      <span>Pentagram One:</span> Personal Planets
                    </p>
                    <p>
                      <span>Planets:</span> Sun, Moon, Mercury, Venus, Mars
                    </p>
                    <p>
                      <span>Focus:</span> This pentagram is dedicated to the
                      exploration and enhancement of personal attributes such as
                      emotions, communication, individuality, love, and
                      proactive endeavors. It is deeply rooted in the self,
                      serving as a foundation for personal growth and
                      development.
                    </p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="/image/school_ritual_psd4_block7_mainWrp_bg_21Aug.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block8-------------------  */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block8_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <p>
                      <span>Pentagram Two:</span> Social and Transpersonal
                      Planets
                    </p>
                    <p>
                      <span>Planets:</span> Jupiter, Saturn, Uranus, Neptune,
                      Pluto
                    </p>
                    <p>
                      <span>Focus:</span> Encompassing the influences that
                      extend beyond the individual, this pentagram includes
                      societal structures, expansion, rebellion, spiritual
                      enlightenment, and profound transformation.
                    </p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="/image/school_ritual_psd4_block8_mainWrp_bg_21Aug.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block9-------------------  */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block9_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h3>Symbolic Reasoning and Astrological Alignment</h3>

                    <p>
                      <span>Pentagram One:</span> Right-Side Up
                    </p>
                    <p>
                      <span>Symbolic Reasoning:</span> The upright pentagram
                      symbolizes spiritual ascendancy, with the top point
                      emphasizing the triumph of spirit over the material
                      elements. This orientation reflects a proactive engagement
                      with life’s personal challenges, aligning with the
                      intimate focus of the personal planets.
                    </p>
                    <p>
                      <span>Astrological Alignment:</span> Aligning personal
                      aspects with the upright pentagram accentuates mastery
                      over one’s energies, encouraging the positive development
                      of personal traits and spiritual growth.
                    </p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd4_block9_mainWrp_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block10-------------------  */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block10_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <p>
                      <span>Pentagram Two:</span> Upside-Down
                    </p>
                    <p>
                      <span>Symbolic Reasoning:</span> The upside-down pentagram
                      is reinterpreted here as a representation of cosmic
                      energies influencing the spiritual journey. This
                      orientation symbolizes how external, universal forces
                      shape, challenge, and expand personal and collective
                      spiritual landscapes.
                    </p>
                    <p>
                      <span>Astrological Alignment:</span> The social and
                      transpersonal planets act as guides and catalysts,
                      inviting deep reflection and transformative shifts in
                      spiritual consciousness and personal paradigms. This
                      configuration emphasizes a receptive relationship to
                      broader cosmic energies, promoting spiritual growth and
                      integration.
                    </p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="/image/school_ritual_psd4_block10_mainWrp_bg_new.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block11-------------------  */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block11_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h3>Detailed Element Description</h3>

                    <p>
                      <span>Pentagram One:</span> Right-Side Up{" "}
                    </p>
                    <p>
                      <span>Sun (Spirit):</span> At the top point, the Sun
                      symbolizes the spirit’s supremacy over material concerns,
                      radiating leadership, vitality, and the essence of self.
                    </p>
                    <p>
                      <span>Moon (Water):</span> Represents emotional depth,
                      intuition, and the subconscious, enhancing emotional and
                      psychic receptivity.
                    </p>
                    <p>
                      <span>Mercury (Air):</span> Governs the realms of
                      communication and intellect, facilitating the flow and
                      exchange of ideas.
                    </p>
                    <p>
                      <span>Venus (Earth):</span> Symbolizes love, beauty, and
                      material abundance, fostering harmony and tangible beauty
                      in the earthly realm.
                    </p>
                    <p>
                      <span>Mars (Fire):</span> Embodies assertive energy,
                      passion, and drive, encouraging proactive engagement and
                      overcoming challenges.
                    </p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="/image/school_ritual_psd4_block11_mainWrp_bg_21Aug.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block12-------------------  */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block12_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <p>
                      <span>Pentagram Two:</span> Upside-Down
                    </p>
                    <p>
                      <span>Jupiter (Fire):</span> Positioned to symbolize
                      expansion and wisdom, Jupiter encourages spiritual and
                      societal growth, turning personal norms into expansive new
                      forms.
                    </p>
                    <p>
                      <span>Saturn (Earth):</span> Represents structure and
                      responsibility, grounding personal aspirations within the
                      framework of societal expectations and karmic lessons.
                    </p>
                    <p>
                      <span>Uranus (Air):</span> Embodies innovation and change,
                      bringing unexpected shifts and fresh perspectives to
                      societal norms.
                    </p>
                    <p>
                      <span>Neptune (Water):</span> Symbolizes spiritual depth,
                      dreams, and intuition, dissolving boundaries and enhancing
                      spiritual awareness.
                    </p>
                    <p>
                      <span>Pluto (Spirit):</span> At the deepest point, Pluto
                      signifies transformation and renewal, marking profound
                      spiritual rebirths that reshape personal and collective
                      realities.
                    </p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="/image/school_ritual_psd4_block12_mainWrp_bg_21Aug.webp"
                    alt="Image"
                  />

                  <img
                    className={styles.abs_img1}
                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/psd4_block12_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block13-------------------  */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block13_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h3>Conclusion</h3>

                    <p>
                      The arrangement of Pentagram One in an upright position
                      and Pentagram Two in an upside-down position symbolizes a
                      balanced and dynamic interplay between personal
                      empowerment and the transformative influence of cosmic
                      energies. This configuration highlights both the ascent of
                      personal energies and the descent of external forces,
                      facilitating a harmonious dialogue between the individual
                      and the universe, thereby enriching the spiritual journey
                      and emphasizing a positive, transformative interaction
                      with the cosmos.
                    </p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd4_block13_mainWrp_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>



        {/* ---------------------------block25_13Aug-------------------  */}
        {/* <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block24_mainWrp} ${styles.school_ritual_psd4_block24_sub1_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h2>Notes for Advanced Practitioners</h2>
                    <ul>
                      <li> <span> <strong>Aspects as Chorus —</strong> </span> If incorporating major natal aspects, weave only those that materially shape the planet invoked. Keep acknowledgements brief to preserve momentum.</li>
                      <li> <span><strong>Angles Judiciously —</strong> </span> If invoking rulers of MC/DC/IC, schedule them on days when their planets are already being installed to avoid diluting the day’s primary focus.</li>
                      <li> <span><strong>Journaling —</strong></span> After each session, record any changes in state, dream content, or omens. These serve as living oracles, guiding adjustments for the next day’s work.</li>
                    </ul>
                    <p>
                     By the final day of this cycle, every planetary and zodiacal current has been called forth in its original natal context, woven together through the gates and seals into the unified pattern of your incarnation. You will have walked the heavens as they were at your birth, step by deliberate step, re-enthroning the oikeios daimon at the center of your living temple. This is not a symbolic exercise — it is the conscious re-animation of the cosmic blueprint that brought you into being, now fully awake and responsive in the present.
                    </p>

                    <p>
                      From here, the work does not end; it deepens. The chart you have just installed is not a fixed image, but a living architecture through which the gods may continue to act. Each year that you return to this rite, you renew your alignment and sharpen your capacity to move within your own divine measure. Let this seal not be a static imprint, but a luminous engine — the bridge between the heavens above and the soul within — carrying you into the next cycle with clarity, power, and the quiet certainty that you are exactly where the cosmos intends you to be.
                    </p>
                  
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd4_block5_mainWrp_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection> */}

        {/* ---------------------------block25_12Aug-------------------  */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block25_mainWrp} ${styles.school_ritual_psd4_block25_1_12Aug_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div className={styles.column} ref={planetaryResonanceRef}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h2>Planetary Concentrated Resonance in <br />Preparation for Invocation</h2>
                </div>
              </div>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>

                    <p>
                      Just prior to the planetary invocation, and after you have opened the gate, you will engage in a concentrated imaginal operation designed to expand your microcosmic awareness to the scale of the entire solar system. This expansion is a preparatory act, specific to planetary invocation and done in concentrated silence. It can be used in banishing and invocation rites for the planetary gods, but not zodiacal invocations, which do not require this step.
                    </p>

                    {/* <p>

                      This practice is crafted to bring you into direct imaginal contact with the planetary deity—not as a distant symbol or abstract archetype, but as a real, immense, radiant cosmic being, whose presence you engage through breath, visualization, and sacred gesture.

                    </p> */}

                    <p>
                      In this ritual alignment, the body becomes the altar, the hands the vessel, and the inner gaze the bridge between the human microcosm and the divine macrocosm. It is a sacred posture of contact, establishing the conditions necessary for the living presence of the planetary god to enter
                      and permeate the rite.
                    </p>

                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="/image/school_ritual_psd4_block25_1_12Aug_mainWrp_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* --------------------------------------------- */}


        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block24_mainWrp} ${styles.school_ritual_psd4_block25_2_12Aug_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h3>
                      The Gesture of Holding the Planet
                    </h3>
                    <p>
                      Begin by standing within the circle in your ritual posture—grounded, aligned, and still.

                    </p>

                    <p>
                      Clasp your hands together, palms facing each other, fingers curved slightly inward as though holding a large sphere. Feel the subtle magnetic field forming between them. This is the gesture of containment, a sacred mudra through which you will cradle the planetary force.

                    </p>

                    <p>
                      Now, with your imaginal faculty fully engaged, begin to visualize the planet you are about to invoke—not as a symbol, not as a reduced icon, but as it truly exists in the vastness of the solar system:
                    </p>
                    <ul>
                      <li>See it in absolute scale.</li>
                      <li>Feel its true size: a sphere hundreds or thousands of miles across.</li>
                      <li>Sense its gravitational pull, its rotational mass, its field of radiation.</li>
                      <li>Feel the raw physicality of it—the clouds of Venus, the rings of Saturn, the magnetic storms of Jupiter, the glittering ice of Uranus.</li>
                    </ul>
                    <p>
                      Let yourself experience a moment of awe: you are now holding the real planet between your hands.

                    </p>

                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="/image/school_ritual_psd4_block25_2_12Aug_mainWrp_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* -------------------------------------------------------- */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block25_mainWrp} ${styles.school_ritual_psd4_block25_3_12Aug_mainWrp}`}
          >
            <div className={styles.common_width}>

              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>

                    <p>
                      In this moment, you are vaster than the entire solar system, expanded in imaginal and ceremonial consciousness to cradle the god-body of the planet. You are in direct imaginal communion with the planetary deity through its very body in its full strength and measure.

                    </p>

                    <p>

                      The planet radiates force into your hands: heat, pressure, vibration, silence.
                      This energy begins to radiate outward, slowly expanding to fill the entire ritual chamber. You feel it pressing against the walls, saturating the air, moving through the floor and the ceiling, surrounding you in a dense, luminous field.


                    </p>

                    <p>

                      Let the presence grow more real than the room you are in. As you continue to breathe deeply and silently, the planet’s energetic signature begins to interpenetrate your body, drawing your nervous system, breath, and subtle centers into resonance.
                    </p>

                    <p>
                      Inhale slowly, drawing this planetary power into your being. Exhale gently, letting go of all resistance, deepening the experience. Do this for at least three deep breaths, remaining in sacred silence, allowing the planetary presence to become dominant.
                    </p>

                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="/image/school_ritual_psd4_block25_3_12Aug_mainWrp_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ------------------------------------------------------------------------ */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block24_mainWrp} ${styles.school_ritual_psd4_block25_4_12Aug_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h3>
                      Resonating the Name
                    </h3>
                    <p>
                      When the moment feels full—when the imaginal and energetic contact has become stable— then change to the gesture of the planet in question and begin to resonate it’s divine name in the Latin provided below. Allow the name to be a carrier wave, a tonal expression of the planet’s eternal intelligence. As the name vibrates through your body and space, it further crystallizes the presence of the planetary deity. Let the name and the form merge, until you are not just invoking the planet—you are becoming the temple in which its presence abides.

                    </p>

                    {/* <p>
                      Remain here for as long as needed. When complete, allow the hands to relax slowly. Do not break the posture abruptly. Let the energetic field settle and descend like mist and then move to the next stage whether that be closing the ritual or moving into a
                      zodiacal invocation.

                    </p> */}

                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="/image/school_ritual_psd4_block25_4_12Aug_mainWrp_bg_20aug_new.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>


        {/* -------------------------------------------------------- */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block25_mainWrp} ${styles.school_ritual_psd4_block25_5_12Aug_mainWrp}`}
          >
            <div className={styles.common_width}>

              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h3>Alternative Option: Using Stones or Planetary Objects</h3>

                    <p>
                      While the imaginal holding of the actual planet is the central practice, there is also a material companion practice that can help anchor and stabilize the energy, especially for those who benefit from tactile grounding.

                    </p>

                    <p>


                      You may choose to select stones, crystals, or objects that correspond to each
                      planetary deity. These can be held in the hands during the meditation or placed on your altar afterward. The objects serve not merely as symbols but as condensation
                      points—physical carriers of planetary resonance that your body can attune to.



                    </p>



                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="/image/school_ritual_psd4_block25_5_12Aug_mainWrp_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>


        {/* ---------------------------------------------------------------- */}

        <LazySection>
          <div
            className={` ${styles.school_ritual_psd4_block25_6_12Aug_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec}>
                <h3>Here are some traditional associations (adapt these as you see fit):</h3>
                <div className={styles.school_ritual_psd4_block25_6_12Aug_1199px_flx}>

                  <div className={`${styles.school_ritual_psd4_block25_6_12Aug_main_subsec_flx} ${styles.psd4_block25_6_12Aug_border}`}>
                    <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini}>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_1sticon}>
                        <img src="/image/ritual_sun_icon.png" alt="Icon" />
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_2ndText}>
                        <p><span>Sun:</span> Sunstone, Citrine, or Gold</p>
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_3rdLogo}>
                        <img src="/image/sun_green_stone.png" alt="Logo" />
                      </div>


                    </div>

                    <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini}>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_1sticon}>
                        <img src="/image/ritual_moon_icon.png" alt="Icon" />
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_2ndText}>
                        <p><span>Moon:</span> Moonstone or Selenite</p>
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_3rdLogo}>
                        <img src="/image/moon_stone.png" alt="Logo" />
                      </div>


                    </div>

                    <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini}>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_1sticon}>
                        <img src="/image/ritual_marcury_icon.png" alt="Icon" />
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_2ndText}>
                        <p><span>Mercury:</span> Emerald, Agate, or Fluorite</p>
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_3rdLogo}>
                        <img src="/image/marcury_stone.png" alt="Logo" />
                      </div>


                    </div>

                    <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini}>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_1sticon}>
                        <img src="/image/ritual_venus_icon.png" alt="Icon" />
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_2ndText}>
                        <p><span>Venus:</span> Rose Quartz, Copper, or Jade</p>
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_3rdLogo}>
                        <img src="/image/venus_stone.png" alt="Logo" />
                      </div>


                    </div>

                    <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini}>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_1sticon}>
                        <img src="/image/ritual_mars_icon.png" alt="Icon" />
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_2ndText}>
                        <p><span>Mars:</span> Red Jasper, Carnelian, or Iron</p>
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_3rdLogo}>
                        <img src="/image/mars_stone.png" alt="Logo" />
                      </div>


                    </div>
                  </div>



                  <div className={`${styles.school_ritual_psd4_block25_6_12Aug_main_subsec_flx} ${styles.psd4_block25_6_12Aug_border_ex}`}>
                    <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini}>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_1sticon}>
                        <img src="/image/ritual_jupitar_icon.png" alt="Icon" />
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_2ndText}>
                        <p><span>Jupiter:</span> Lapis Lazuli, Amethyst, or Tin</p>
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_3rdLogo}>
                        <img src="/image/jupitar_stone.png" alt="Logo" />
                      </div>


                    </div>

                    <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini}>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_1sticon}>
                        <img src="/image/ritual_sutarn_icon.png" alt="Icon" />
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_2ndText}>
                        <p><span>Saturn:</span> Obsidian, Onyx, Lead, or Hematite</p>
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_3rdLogo}>
                        <img src="/image/saturn_stone.png" alt="Logo" />
                      </div>


                    </div>

                    <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini}>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_1sticon}>
                        <img src="/image/ritual_urenus_icon.png" alt="Icon" />
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_2ndText}>
                        <p><span>Uranus:</span> Labradorite, Aquamarine</p>
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_3rdLogo}>
                        <img src="/image/uranus_stone.png" alt="Logo" />
                      </div>


                    </div>

                    <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini}>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_1sticon}>
                        <img src="/image/ritual_nepchun_icon.png" alt="Icon" />
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_2ndText}>
                        <p><span>Neptune:</span> Larimar, Blue Lace Agate</p>
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_3rdLogo}>
                        <img src="/image/neptune_stone.png" alt="Logo" />
                      </div>


                    </div>

                    <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini}>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_1sticon}>
                        <img src="/image/ritual_pluto_icon.png" alt="Icon" />
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_2ndText}>
                        <p><span>Pluto:</span> Black Tourmaline, Obsidian, or Meteorite</p>
                      </div>
                      <div className={styles.school_ritual_psd4_block25_6_12Aug_main_subsec_mini_3rdLogo}>
                        <img src="/image/pluto_stone.png" alt="Logo" />
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LazySection>




        {/* ------------------------------------------------------------------------ */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block24_mainWrp} ${styles.school_ritual_psd4_block25_7_12Aug_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h3>
                      If you use stones:
                    </h3>

                    <ul>
                      <li>Hold them in your hands during the planetary gesture, letting your breath and imaginal self magnify their resonance.</li>
                      <li>Or, place them on your altar or body during the ritual, charging them with the presence you’ve invoked.</li>
                      <li>  Over time, these stones become <span>personal talismans</span>, saturated with the living current of the planetary deity.</li>
                    </ul>
                    <p>
                      This tactile approach does not replace the imaginal method—it <span>supports and stabilizes it</span>, allowing for a layered and embodied engagement.

                    </p>

                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="/image/school_ritual_psd4_block25_7_12Aug_mainWrp_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>




        {/* ---------------------------block25_12Aug-------------------  */}

        {/* ---------------------------blockNew_19Aug-------------------  */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block13_mainWrp} ${styles.school_ritual_psd4_blockNew_19Aug_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div className={styles.column} ref={planetaryIntelligenciesRef}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h2>THE PLANETARY ARCHETYPES AND DIVINE INTELLIGENCES</h2>
                </div>
              </div>

              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    {/* <h2 ref={theSunArchetypeRef}>Sun Invocation</h2> */}
                    <h6>Introduction to the Planetary Invocations</h6>


                    <p>
                      The descriptions that follow present several aspects of the planets in their <span>mundane expressions</span>—the qualities, tendencies, and influences by which they commonly act in the world and in human affairs. These are important for orientation, for they provide the language and framework through which the planetary powers are recognized. Yet these outer qualities are but the <span>outer garment of the gods</span>.
                    </p>
                    {/* <h3><span>2. Enhanced Self-Awareness</span></h3> */}
                    <p>
                      In the act of theurgical invocation, the relationship deepens beyond description. Here the theurgist does not merely contemplate planetary attributes but enters into <span>ecstatic union</span> with the planetary god itself. The god descends, and the theurgist is taken up, possessed in sacred intimacy. This union is not an abstraction but a lived transformation, wherein the soul is drawn into the divine pedagogy <span>(paideia)</span> of the god and is transformed. Each planetary presence becomes a teacher, shaping, instructing, and transfiguring the theurgist from within.
                    </p>

                    <p>
                      In this state, visions arise that are far more <span>personal and revelatory</span> than any general list of attributes could suggest, revealing mysteries that cannot be predetermined. The invocations thus serve as <span>gateways</span>—the opening words that draw the divine into presence—but the true content of the encounter is experiential, a dialogue of possession, transformation, and divination.
                    </p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="/image/Introduction_Aug20_sun_bg_update.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------blockNew_19Aug-------------------  */}



        {/* ---------------------------block14-------------------  */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block14_mainWrp}`}
          >
            <div className={styles.common_width}>
              {/* <div className={styles.column} ref={planetaryIntelligenciesRef}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h2>THE PLANETARY ARCHETYPES AND DIVINE INTELLIGENCES</h2>
                </div>
              </div> */}

              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h2 ref={theSunArchetypeRef}>Sun Invocation</h2>
                    <h6>The sun Archetype - Divine intelligence</h6>
                    <h3><span>1. Clarity and Purification of Intent</span></h3>

                    <p>
                      By actively banishing negative traits such as egoism and
                      arrogance, you purify your mental and emotional state.
                      This purification clears the way for a more unobstructed
                      perception of your true motivations and desires. It strips
                      away the superficial layers that often distort
                      self-perception and judgment, allowing the essence of the
                      Sun—clarity, vitality, and authenticity—to shine through.
                    </p>
                    <h3><span>2. Enhanced Self-Awareness</span></h3>
                    <p>
                      Invoking positive traits such as vitality and creativity
                      brings you closer to understanding your core self. This
                      process enhances self-awareness, enabling you to perceive
                      and align more closely with your true potential and
                      purpose. As these traits are magnified, you begin to see
                      yourself as an active creator in your life, capable of
                      leadership and influence, which are essential qualities of
                      the Sun.
                    </p>
                    <h3><span>3. Intuitive Decision-Making</span></h3>
                    <p>
                      With increased self-awareness and clarity, your
                      decision-making process becomes more intuitive. You start
                      to rely more on your inner guidance system, recognizing
                      and trusting the subtle impulses that guide you towards
                      your highest good. This intuitive process is a direct
                      result of embracing the Sun’s energy, leading to decisions
                      that not only serve your individual growth but also
                      reflect your true self.
                    </p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd4_block14_mainWrp_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block15-------------------  */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block15_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h3><span>4. Recognition of Universal Connectivity</span></h3>

                    <p>
                      As you embody the Sun’s qualities, you begin to see how
                      your personal energy and actions influence and are
                      influenced by the world around you. This recognition of
                      connectivity is a direct perception of the archetype,
                      where you understand your role in the larger cosmos. You
                      see how leadership and creativity are not just personal
                      traits but are services to the collective, reflecting the
                      Sun’s role in sustaining life and vitality.
                    </p>
                    <h3><span>5. Manifestation of Potential</span></h3>
                    <p>
                      The Sun is a symbol of manifesting potential and life
                      force. By integrating this archetype, you not only
                      perceive your potential but are also empowered to manifest
                      it. This leads to a life that is not only lived more fully
                      but is also a direct expression of your highest and most
                      authentic self.
                    </p>

                    <p>
                      Through this ritual praxis, you refine your ability to
                      perceive and integrate the archetypal power of the Sun
                      directly. This integration results in a transformative
                      effect on your consciousness, enhancing your ability to
                      lead, create, and influence in alignment with your true
                      self, ultimately leading to a more profound and divinatory
                      state of awareness.
                    </p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd4_block15_mainWrp_bg.webp"
                    alt="Image"
                  />

                  <img
                    className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd4_block15_mainWrp_bg_new.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block16-------------------  */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block16_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h3>Ritual Praxis of the Planetary Intelligence</h3>

                    <p>
                      Once completing the opening of the gates of spirit,
                      staying still and centralized within the ritual space,
                      focusing on the infinite center of being and the spherical
                      self boundary as the total immortal and infinite self,
                      make the gesture of the Sun. Hold for one to three full
                      breaths then make the pronouncement and resonate the
                      Divine Name of the Planetary Intelligence.
                    </p>

                    <p>
                      <span>
                        Pronouncement: "In nomine Solis, fontem lucis et vitae,"
                      </span>
                    </p>
                    <p>
                      <span>
                        Translation: "In the name of Sol, source of light and
                        life,"
                      </span>
                    </p>
                    <p>
                      <span>
                        Phonetics: "In noh-mee-nay Soh-lees, fohn-tem loo-sees
                        et vee-tie,"
                      </span>
                    </p>
                    <div className={styles.clippathsec}>
                      <p>Resonate Divine Name <span>(1 to 3 times)</span></p>
                    </div>

                    <p>
                      <span className={styles.color_white}>Sun / Latin:</span>{" "}
                      <span>Sol (SOHL) - SOOOOHHHHHLLLLLL</span>
                    </p>
                    <p>
                      If banishing, focus on a purification of the Sun’s
                      archetype within the personal psychology and energetic
                      being. If invoking, focus on the unity between the self
                      and the self boundary as a total unity allowing the Divine
                      Intelligence of the Higher Being of the Sun to possess and
                      transform. Hold the sign of silence for at least three
                      full breaths afterward focusing on the purity of the
                      Archetype if Banishing or allowing the Planetary
                      Intelligence to fully embody if Invoking.{" "}
                    </p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="/image/school_ritual_psd4_block16_mainWrp_bg_new.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block17-------------------  */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block17_mainWrp}`}

          >
            <div className={styles.common_width}>
              {/* <div className={styles.column}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h2>
                    The Moon Archetype - Divine Intelligence</h2>
                </div>
              </div> */}

              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h2 ref={theMoonArchetypeRef}>Moon Invocation</h2>
                    <h6>The Moon Archetype - Divine Intelligence</h6>
                    <h3><span>1. Emotional Clarity and Stability</span></h3>

                    <p>
                      By consciously banishing traits like emotional
                      instability, over-sensitivity, and moodiness, you aim to
                      achieve emotional clarity and stability. This purification
                      allows for a more balanced emotional state, making it
                      easier to navigate life's ups and downs without being
                      overwhelmed by transient feelings.
                    </p>
                    <h3><span>2. Enhanced Intuitive and Psychic Abilities</span></h3>
                    <p>
                      Invoking the Moon's qualities such as emotional depth,
                      intuition, and psychic abilities enhances your connection
                      to your subconscious mind. As these traits are
                      strengthened, you become more attuned to the undercurrents
                      of your psyche, allowing for a richer, more nuanced
                      understanding of yourself and your environment.
                    </p>
                    <h3><span>3. Deepened Relationships and Nurturing</span></h3>
                    <p>
                      With the Moon influencing your daily interactions,
                      particularly in family life and caregiving, you cultivate
                      deeper, more empathetic relationships. By nurturing others
                      and reflecting on your emotional states, you embody the
                      Moon’s energy of care and connectivity, strengthening
                      bonds and enhancing your emotional support network.
                    </p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd4_block17_mainWrp_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block18-------------------  */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block18_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h3><span>4. Connection to the Inner World</span></h3>

                    <p>
                      Regular reflection and attention to dreams and
                      subconscious messages open a direct line to your inner
                      world. This practice allows you to harness the Moon’s
                      power of reflection and introspection, leading to profound
                      self-discovery and personal growth.
                    </p>
                    <h3><span>5. Manifestation of Nurturing Environments</span></h3>
                    <p>
                      As you integrate the Moon’s qualities into your daily
                      life, especially within the home environment, you create a
                      nurturing and supportive space. This environment not only
                      benefits you but also those around you, reflecting the
                      Moon’s role in fostering security and emotional
                      well-being.
                    </p>

                    <p>
                      Through this ritual praxis, you refine your ability to
                      perceive and integrate the archetypal power of the Moon
                      directly. This integration results in a transformative
                      effect on your emotional intelligence, enhancing your
                      capacity to nurture, reflect, and connect deeply with both
                      your inner world and the people around you.
                    </p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd4_block18_mainWrp_bg.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>

        {/* ---------------------------block19-------------------  */}

        <LazySection>
          <div
            className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd4_block19_mainWrp}`}
          >
            <div className={styles.common_width}>
              <div
                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
              >
                <div className={styles.school_ritual_txt_box_wrpr}>
                  <div className={styles.school_ritual_txt_box_innr}>
                    <h3>Ritual Praxis of the Planetary Intelligence</h3>

                    <p>
                      Once completing the opening of the gates of water, staying
                      still and centralized within the ritual space, focusing on
                      the infinite center of being and the spherical self
                      boundary as the total immortal and infinite self, make the
                      gesture of the Moon. Hold for one to three full breaths
                      then make the pronouncement and resonate the Divine Name
                      of the Planetary Intelligence.
                    </p>
                    <p>
                      <span>
                        Pronouncement: "In nomine Lunae, dominae noctis et
                        somniorum,"
                      </span>
                    </p>
                    <p>
                      <span>
                        Translation: "In the name of Luna, lady of the night and
                        dreams,"
                      </span>
                    </p>
                    <p>
                      <span>
                        Phonetics: "In noh-mee-nay Loo-nay, doh-mee-nay nok-tees
                        et som-nee-oh-rum,"
                      </span>
                    </p>

                    <div className={styles.clippathsec}>
                      <p>Resonate Divine Name <span>(1 to 3 times)</span></p>
                    </div>

                    <p>
                      <span className={styles.color_white}>Moon / Latin: </span>{" "}
                      <span>Luna (LOO-Nah) - LOOOO-naaaaaahhhhh</span>
                    </p>

                    <p>
                      If banishing, focus on a purification of the Moon’s
                      archetype within the personal psychology and energetic
                      being. If invoking, focus on the unity between the self
                      and the self boundary as a total unity allowing the Divine
                      Intelligence of the Higher Being of the Moon to possess
                      and transform. Hold the sign of silence for at least three
                      full breaths afterward focusing on the purity of the
                      Archetype if Banishing or allowing the Planetary
                      Intelligence to fully embody if Invoking.
                    </p>
                  </div>
                </div>

                <div className={styles.school_ritual_img_box_wrpr}>
                  <img
                    className={styles.school_ritual_img1}
                    src="/image/school_ritual_psd4_block19_mainWrp_bg_1new.webp"
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </LazySection>
      </div>
    </>
  );
}

export default SchoolRitualBlockFour;
